/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Injectable } from '@angular/core'
import { catchError, map } from 'rxjs/operators'
import { Observable, of } from 'rxjs'
import { FALLBACK_ADMIN_PLATFORM_SETTINGS, FALLBACK_ADMIN_INFO } from 'src/environments/go-api-fallbacks'

import { ApiService } from '@shared/services/api.service'
import { withFeedback } from '@app/core/interceptors/feedback-context'
import { InputAdminTeamUser, User, UserInList } from '@shared/models/user.model'
import { Setting } from '@shared/models/setting.model'
import { toFormData } from '@core/helpers/to-form-data'
import { PagesData } from '@shared/models/pages-data.model'
import { ExportFileTypes } from '@shared/models/export-file-types.enum'
import { FilterValues } from '@shared/models/filter-values.model'
import { PlatformSettings } from '@shared/models/platform-settings.model'
import { PlatformSettingsForm } from '@shared/common-components/platform-settings-form/platform-settings-form.model'
import { AdminInfo } from '@app/shared/models/billing.model'

@Injectable({ providedIn: 'root' })
export class AdminTeamService {
  constructor(private apiService: ApiService) {}

  getAdminTeam(
    pageIndex = 0,
    pageSize = 10,
    sort?: string,
    filterValues?: FilterValues,
    fields?: (keyof User)[],
  ): Observable<PagesData<User>> {
    const toUser = (user: User) => new User(user)

    // TODO: switch when Go supports paginated list
    return this.apiService
      .getPageable<User>('/admin/users', pageIndex, pageSize, sort, filterValues, fields)
      .pipe(map(({ data, ...rest }) => ({ data: data.map(toUser), ...rest })))
  }

  getAdminInfo(): Observable<AdminInfo> {
    return this.apiService.get('/admin/info').pipe(
      map((resp) => resp['data']),
      catchError(() => of(FALLBACK_ADMIN_INFO as unknown as AdminInfo)),
    )
  }

  updateAdminInfo(info: AdminInfo): Observable<AdminInfo> {
    return this.apiService.post('/admin/info', info, { context: withFeedback() }).pipe(map((resp) => resp['data']))
  }

  getUserList(filterValues?: FilterValues, fields?: (keyof User)[]): Observable<UserInList[]> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params: { [k: string]: any; 'fields[]': (keyof User)[] } = {
      page: 0,
      limit: 1000,
      'fields[]': fields || ['id', 'name', 'surname', 'team'],
      ...filterValues,
    }

    return this.apiService
      .get('/admin/users', { params })
      .pipe(map((response) => response['data'].map((user) => new User(user)))) as Observable<UserInList[]>
  }

  getUser(id: number | string): Observable<User> {
    return this.apiService.get(`/admin/users/${id}`).pipe(map((resp) => new User(resp['data'])))
  }

  updateSettings(data: Partial<Setting>): Observable<Setting[]> {
    return this.apiService
      .patch(`/settings/admin`, data, { context: withFeedback() })
      .pipe(map((resp) => resp['data'].map((item) => new Setting(item))))
  }

  updateUser(id: number | string, user: InputAdminTeamUser): Observable<User> {
    return this.apiService
      .post(`/admin/users/${id}`, toFormData(user), { context: withFeedback() })
      .pipe(map((response) => new User(response['data'])))
  }

  addUser(user: Partial<InputAdminTeamUser>): Observable<User> {
    return this.apiService.post(`/users/admin`, user, { context: withFeedback() }).pipe(map((resp) => new User(resp['data'])))
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addClientsToManager(managerId: number | string, data: any): Observable<User> {
    return this.apiService.patch(`/admin/users/${managerId}/teams`, data, { context: withFeedback() }).pipe(map((resp) => resp['data']))
  }

  exportFile(columns: string[], sort: string, filterValues: FilterValues, type: ExportFileTypes): Observable<string> {
    return this.apiService.exportFile(`/users/${type}`, columns, sort, filterValues)
  }

  archive(userId: number | string): Observable<User> {
    return this.apiService
      .patch(`/users/${userId}/archive`, {}, { context: withFeedback() })
      .pipe(map((response) => new User(response['data'])))
  }

  delete(userId: number | string) {
    // Success-only: the user-list component surfaces delete errors via its own error dialog,
    // so suppress the interceptor error toast to avoid double-reporting.
    return this.apiService.delete(`/admin/users/${userId}`, { context: withFeedback(null, { onError: false }) })
  }

  restore(userId: number | string): Observable<User> {
    return this.apiService.post(`/users/${userId}/restore`, {}, { context: withFeedback() }).pipe(map((resp) => new User(resp['data'])))
  }

  updatePlatformSettings(formdata: PlatformSettingsForm): Observable<PlatformSettings> {
    return this.apiService.post(`/admin/platform-settings`, toFormData(formdata, null, null, ['logo', 'favicon']), {
      context: withFeedback(),
    })
  }

  getPlatformSettings(): Observable<PlatformSettings> {
    return this.apiService.get(`/admin/platform-settings`).pipe(
      map((resp) => resp?.['data'] || resp),
      catchError(() => of(FALLBACK_ADMIN_PLATFORM_SETTINGS as unknown as PlatformSettings)),
    )
  }
}
